module.exports = __webpack_public_path__ + "img/1F92A.31aec23d.svg";